import { ICellRendererParams, ValueFormatterParams } from 'ag-grid-community'
import clsx from 'clsx'
import { AssetInformationModal, LinkButton } from 'components/core-v2'
import { FC, useState } from 'react'
import { Link } from 'react-router-dom'
import { displayPercentage, formatUnits } from 'utilities/number'

import { ApiAccountDashboardAsset } from '@/api'
import { CURRENCY } from '@/const'
import { formatCurrency, formatCurrencyFull } from '@/utilities/currency'

import classes from './cells.module.scss'

/* Cell renderers */
interface LinkCellProps {
  to: string
}
export const LinkCell: FC<LinkCellProps> = ({ children, to }) => (
  <Link className={clsx(classes.link, classes.ellipsis)} to={to}>
    {children}
  </Link>
)

interface CurrencyCellProps {
  currencyFieldName?: string
  fieldName?: string
  variant?: 'full' | 'rounded'
}

interface UnitsCellProps {
  fieldName?: string
}

export const DateCell =
  ({ fieldName }: UnitsCellProps) =>
  ({ data }: ICellRendererParams<any>) => {
    const value = fieldName ? data[fieldName] : undefined
    if (!value) return '-'
    const date = new Date(value)
    return Number.isNaN(date.getTime()) ? '-' : date.toLocaleDateString('en-GB')
  }

export const CurrencyCell =
  ({ currencyFieldName, fieldName, variant = 'rounded' }: CurrencyCellProps) =>
  ({ data }: ICellRendererParams<any>) => {
    const formatFunction = variant === 'full' ? formatCurrencyFull : formatCurrency
    return formatFunction(data[fieldName], currencyFieldName ? data[currencyFieldName] : CURRENCY)
  }

export const UnitsCell =
  ({ fieldName }: UnitsCellProps) =>
  ({ data }: ICellRendererParams<any>) =>
    formatUnits(data[fieldName])

export const AssetNameCell = ({
  data: { assetId, name }
}: ICellRendererParams<ApiAccountDashboardAsset>) => {
  const [isOpen, setIsOpen] = useState(false)

  const onOpen = () => setIsOpen(true)
  const onClose = () => setIsOpen(false)

  return (
    <>
      <LinkButton
        className={clsx(classes.nameCell, classes.ellipsis)}
        title={name}
        onClick={onOpen}
      >
        {name}
      </LinkButton>
      <AssetInformationModal assetId={assetId} isOpen={isOpen} onClose={onClose} />
    </>
  )
}

/* Cell formatters */
export const PercentageFormatter = (params: ValueFormatterParams<any, number>) =>
  displayPercentage(params.value, 2)

/* Cell styles */
export const cellWarningStyle = {
  color: 'var(--Error)',
  background: 'var(--ErrorBG)'
}
